import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import PercentageDataPod from '../../../components/PercentageDataPod';

const messages = defineMessages({
  title: {
    id: 'hubs.student-life.living-on-campus.title',
    defaultMessage: 'Students Living On Campus',
  },
  learnMore: {
    id: 'hubs.student-life.living-on-campus.learn-more',
    defaultMessage: 'Learn More About Housing',
  },
});

const LivingOnCampus = ({ liveOnCampus, intl }) => {
  const title = intl.formatMessage(messages.title);

  return liveOnCampus && !Number.isNaN(+liveOnCampus) ? (
    <PercentageDataPod
      header={title}
      ariaLabel={`${title}, ${liveOnCampus}%`}
      content={{
        values: [
          {
            label: 'default',
            value: +liveOnCampus,
          },
        ],
        type: 'purple',
        linkText: intl.formatMessage(messages.learnMore),
        linkUrl: 'Student_Life#housing-information',
      }}
    />
  ) : null;
};

LivingOnCampus.propTypes = {
  liveOnCampus: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(LivingOnCampus);
